import React, { useContext, useEffect, useRef } from 'react'
// import Sidebar from './sidebar'
import SelectDropDown from '../../../components/react-Select/SelectDropDown'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm, useWatch } from 'react-hook-form'
import { LayoutsContext } from '../../../contexts/settings/layouts.context'
import { fileuploadIcon } from '../../../utils/images/imagepath'
import useFilePreview from '../../../hooks/useFilePreview'
import SettingsMenu from './systemDefinitions/settingsMenu'
import { useSelector } from 'react-redux'
import AccessDenied from '../../authentication/accessDenied'

const LayoutSettings = () => {
  const { info, isSuperAdmin } = useSelector((state: any) => state?.role)
  const roles: any = info || {}
  const isSAdmin: any = isSuperAdmin || false
  const layout_settings = isSAdmin || roles?.layout_settings

  const _layoutsCaptchaRef = useRef(null)
  const {
    submitlayoutsForm,
    layoutsFormSchema,
    errorMessage,
    loading,
    getLayoutData,
  } = useContext(LayoutsContext)

  const {
    handleSubmit: layoutsFormAction,
    control: layoutsFormControl,
    setValue: layoutsFormSetValue,
    formState: { errors: layoutsFormErrors },
    clearErrors: layoutsclearErrors,
    watch,
    register,
  } = useForm({
    resolver: yupResolver<any>(layoutsFormSchema),
    defaultValues: {
      primary_color: '#9751F2',
      secondary_color: '#1DB8CE',
    },
  })

  const login_background_image_File = watch('login_background_image')
  const [loginBgImg]: any = useFilePreview(login_background_image_File)

  const logo_File = watch('logo')
  const [logoImg]: any = useFilePreview(logo_File)

  const loadAnimImg_File = watch('loading_animation')
  const [loadingAnimationImg]: any = useFilePreview(loadAnimImg_File)

  const favicon_File = watch('favicon')
  const [faviconImg]: any = useFilePreview(favicon_File)
  const layoutsettings = useSelector((state: any) => state?.layoutsettings)
  useEffect(() => {
    if (layoutsettings?.google_recaptcha === true) {
      layoutsFormSetValue('google_recaptcha', { label: 'Enabled', value: '1' })
    } else if (layoutsettings?.google_recaptcha === '') {
      layoutsFormSetValue('google_recaptcha', { label: 'Disabled', value: '0' })
    }

    layoutsFormSetValue('application_title', layoutsettings?.application_title)
    layoutsFormSetValue(
      'administration_email',
      layoutsettings?.administration_email,
    )
    layoutsFormSetValue('favicon', layoutsettings?.favicon)
    layoutsFormSetValue('loading_animation', layoutsettings?.loading_animation)
    layoutsFormSetValue(
      'login_background_image',
      layoutsettings?.login_background_image,
    )
    layoutsFormSetValue('logo', layoutsettings?.logo)
    layoutsFormSetValue('primary_color', layoutsettings?.primary_color)
    layoutsFormSetValue(
      'recaptcha_secret_key',
      layoutsettings?.recaptcha_secret_key,
    )
    layoutsFormSetValue(
      'recaptcha_site_key',
      layoutsettings?.recaptcha_site_key,
    )
    layoutsFormSetValue(
      'recaptcha_site_key',
      layoutsettings?.recaptcha_site_key,
    )
    layoutsFormSetValue('site_address', layoutsettings?.site_address)
    layoutsFormSetValue('site_title', layoutsettings?.site_title)
  }, [layoutsettings])

  return (
    <div className='row'>
      <SettingsMenu />
      <div className='col-lg-9'>
        {layout_settings ? (
          <form onSubmit={layoutsFormAction(submitlayoutsForm)}>
            <div className='card'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-lg-12'>
                    <div className='table-title'>
                      <h4>Layout Settings</h4>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Site Title</label>
                      <Controller
                        name='site_title'
                        control={layoutsFormControl}
                        render={({ field: { value, onChange } }) => (
                          <div>
                            <input
                              value={value || ''}
                              onChange={onChange}
                              type='text'
                              maxLength={25}
                              className={`form-control ${
                                layoutsFormErrors.site_title
                                  ? 'border border-danger'
                                  : ''
                              }`}
                            />
                          </div>
                        )}
                      />
                      <small className='text-danger'>
                        {layoutsFormErrors?.site_title?.message}
                      </small>
                      {/* <input type='text' value='john.doe@companyemail.com' /> */}
                    </div>
                  </div>
                  <div className='col-lg-3 col-md-12'>
                    <div className='form-input'>
                      <label>Primary Color</label>
                      <span className='color-picker'>
                        <label htmlFor='colorPicker'>
                          <Controller
                            name='primary_color'
                            control={layoutsFormControl}
                            render={({ field: { value, onChange } }) => (
                              <>
                                <input
                                  value={value || '#9751F2'}
                                  onChange={onChange}
                                  type='color'
                                  id='colorPicker'
                                  className={`${
                                    layoutsFormErrors?.primary_color
                                      ? 'border border-danger'
                                      : ''
                                  }`}
                                />
                                <span> {value}</span>
                              </>
                            )}
                          />
                          <small className='text-danger'>
                            {layoutsFormErrors?.primary_color?.message}
                          </small>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className='col-lg-3 col-md-12'>
                    <div className='form-input'>
                      <label>Secondary Color</label>
                      <span className='color-picker'>
                        <label htmlFor='colorPickers'>
                          <Controller
                            name='secondary_color'
                            control={layoutsFormControl}
                            render={({ field: { value, onChange } }) => (
                              <>
                                <input
                                  value={value || '#1DB8CE'}
                                  onChange={onChange}
                                  type='color'
                                  id='colorPickers'
                                  className={`${
                                    layoutsFormErrors?.secondary_color
                                      ? 'border border-danger'
                                      : ''
                                  }`}
                                />
                                <span> {value}</span>
                              </>
                            )}
                          />
                          <small className='text-danger'>
                            {layoutsFormErrors?.secondary_color?.message}
                          </small>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Application Title</label>
                      <Controller
                        name='application_title'
                        control={layoutsFormControl}
                        render={({ field: { value, onChange } }) => (
                          <div>
                            <input
                              value={value || ''}
                              onChange={onChange}
                              type='text'
                              maxLength={25}
                              className={`form-control ${
                                layoutsFormErrors?.application_title
                                  ? 'border border-danger'
                                  : ''
                              }`}
                            />
                          </div>
                        )}
                      />
                      <small className='text-danger'>
                        {layoutsFormErrors?.application_title?.message}
                      </small>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Google Recaptcha v2</label>
                      <SelectDropDown
                        options={[
                          { label: 'Enabled', value: '1' },
                          { label: 'Disabled', value: '0' },
                        ]}
                        module={'google_recaptcha'}
                        value={
                          layoutsettings?.google_recaptcha === true
                            ? { label: 'Enabled', value: '1' }
                            : { label: 'Disabled', value: '0' }
                        }
                        placeholder={'Select google recaptcha...'}
                        formControl={layoutsFormControl}
                        formControlErr={layoutsFormErrors}
                        formSetvalue={layoutsFormSetValue}
                        formClrearErr={layoutsclearErrors}
                        ref={_layoutsCaptchaRef}
                      />
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Site Address</label>
                      <Controller
                        name='site_address'
                        control={layoutsFormControl}
                        render={({ field: { value, onChange } }) => (
                          <div>
                            <input
                              value={value || ''}
                              onChange={onChange}
                              type='text'
                              maxLength={50}
                              className={`form-control ${
                                layoutsFormErrors?.site_address
                                  ? 'border border-danger'
                                  : ''
                              }`}
                            />
                          </div>
                        )}
                      />
                      <small className='text-danger'>
                        {layoutsFormErrors?.site_address?.message}
                      </small>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Recaptcha Secret Key</label>
                      <Controller
                        name='recaptcha_secret_key'
                        control={layoutsFormControl}
                        render={({ field: { value, onChange } }) => (
                          <div>
                            <input
                              value={value || ''}
                              onChange={onChange}
                              type='text'
                              maxLength={50}
                              className={`form-control ${
                                layoutsFormErrors?.recaptcha_secret_key
                                  ? 'border border-danger'
                                  : ''
                              }`}
                            />
                          </div>
                        )}
                      />
                      <small className='text-danger'>
                        {layoutsFormErrors?.recaptcha_secret_key?.message}
                      </small>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Administration Email Address</label>
                      <Controller
                        name='administration_email'
                        control={layoutsFormControl}
                        render={({ field: { value, onChange } }) => (
                          <div>
                            <input
                              value={value || ''}
                              onChange={onChange}
                              type='email'
                              maxLength={50}
                              className={`form-control ${
                                layoutsFormErrors?.administration_email
                                  ? 'border border-danger'
                                  : ''
                              }`}
                            />
                          </div>
                        )}
                      />
                      <small className='text-danger'>
                        {layoutsFormErrors?.administration_email?.message}
                      </small>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Recaptcha Site Key</label>
                      <Controller
                        name='recaptcha_site_key'
                        control={layoutsFormControl}
                        render={({ field: { value, onChange } }) => (
                          <div>
                            <input
                              value={value || ''}
                              onChange={onChange}
                              type='text'
                              maxLength={50}
                              className={`form-control ${
                                layoutsFormErrors?.recaptcha_site_key
                                  ? 'border border-danger'
                                  : ''
                              }`}
                            />
                          </div>
                        )}
                      />
                      <small className='text-danger'>
                        {layoutsFormErrors?.recaptcha_site_key?.message}
                      </small>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Login Background Image</label>
                      <div
                        className={`upload-div ${layoutsFormErrors.login_background_image ? 'img-border-danger border-danger' : ''}`}
                      >
                        <div className='upload-img'>
                          <img
                            src={
                              loginBgImg.file ||
                              layoutsettings?.login_background_image ||
                              fileuploadIcon
                            }
                            alt='img'
                          />
                        </div>
                        <div className='upload-content'>
                          <h6>Select a image or drag and drop here</h6>
                          <span>JPG,JPEG,SVG,PNG</span>
                        </div>
                        <div className='upload-btn'>
                          <Controller
                            name='login_background_image'
                            control={layoutsFormControl}
                            render={({ field: { value, onChange } }) => (
                              <>
                                <input
                                  type='file'
                                  multiple={false}
                                  id='login_background_image'
                                  {...register('login_background_image')}
                                />
                              </>
                            )}
                          />

                          <div className='select-file'>
                            <span>Select file</span>
                          </div>
                        </div>
                      </div>
                      <small className='text-danger login-background-image'>
                        {layoutsFormErrors &&
                          layoutsFormErrors.login_background_image?.message}
                      </small>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Logo Image</label>
                      <div
                        className={`upload-div ${layoutsFormErrors.logo ? 'img-border-danger border-danger' : ''}`}
                      >
                        {/* <div className='upload-img'>
                        <img src={logoImg || fileuploadIcon} alt='img' />
                      </div> */}
                        <div className='upload-img'>
                          <img
                            src={
                              logoImg.file ||
                              layoutsettings?.logo ||
                              fileuploadIcon
                            }
                            alt='img'
                          />
                        </div>
                        <div className='upload-content'>
                          <h6>Select a image or drag and drop here</h6>
                          <span>JPG,JPEG,SVG,PNG</span>
                        </div>
                        <div className='upload-btn'>
                          <Controller
                            name='logo'
                            control={layoutsFormControl}
                            render={({ field: { value, onChange } }) => (
                              <>
                                <input
                                  type='file'
                                  multiple={false}
                                  id='logo'
                                  {...register('logo')}
                                />
                              </>
                            )}
                          />
                          <small className='text-danger'></small>
                          <div className='select-file'>
                            <span>Select file</span>
                          </div>
                        </div>
                      </div>
                      <small className='text-danger login-background-image'>
                        {layoutsFormErrors && layoutsFormErrors.logo?.message}
                      </small>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Loading Animation</label>
                      <div
                        className={`upload-div ${layoutsFormErrors.loading_animation ? 'img-border-danger border-danger' : ''}`}
                      >
                        <div className='upload-img'>
                          <img
                            src={
                              loadingAnimationImg.file ||
                              layoutsettings?.loading_animation ||
                              fileuploadIcon
                            }
                            alt='img'
                          />
                        </div>
                        <div className='upload-content'>
                          <h6>Select a image or drag and drop here</h6>
                          <span>JPG,JPEG,SVG,PNG,GIF</span>
                        </div>
                        <div className='upload-btn'>
                          <Controller
                            name='loading_animation'
                            control={layoutsFormControl}
                            render={({ field: { value, onChange } }) => (
                              <>
                                <input
                                  type='file'
                                  multiple={false}
                                  id='loading_animation'
                                  {...register('loading_animation')}
                                />
                              </>
                            )}
                          />
                          <div className='select-file'>
                            <span>Select file</span>
                          </div>
                        </div>
                      </div>
                      <small className='text-danger login-background-image'>
                        {layoutsFormErrors &&
                          layoutsFormErrors.loading_animation?.message}
                      </small>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12'>
                    <div className='form-input'>
                      <label>Favicon Image</label>
                      <div
                        className={`upload-div ${layoutsFormErrors.favicon ? 'img-border-danger border-danger' : ''}`}
                      >
                        <div className='upload-img'>
                          <img
                            src={
                              faviconImg.file ||
                              layoutsettings?.favicon ||
                              fileuploadIcon
                            }
                            alt='img'
                          />
                        </div>
                        <div className='upload-content'>
                          <h6>Select a image or drag and drop here</h6>
                          <span>JPG,JPEG,SVG,PNG</span>
                        </div>
                        <div className='upload-btn'>
                          <Controller
                            name='favicon'
                            control={layoutsFormControl}
                            render={({ field: { value, onChange } }) => (
                              <>
                                <input
                                  type='file'
                                  multiple={false}
                                  id='favicon'
                                  {...register('favicon')}
                                />
                              </>
                            )}
                          />
                          <div className='select-file'>
                            <span>Select file</span>
                          </div>
                        </div>
                      </div>
                      <small className='text-danger login-background-image'>
                        {layoutsFormErrors &&
                          layoutsFormErrors.favicon?.message}
                      </small>
                    </div>
                  </div>
                  <div className='form-group-btn'>
                    <button type='submit' className='btn btn-save'>
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        ) : (
          <AccessDenied />
        )}
      </div>
    </div>
  )
}

export default LayoutSettings
